import InfiniteList from './infinite-list';
export default InfiniteList;
